enum AquaShellModel {
  AQUASHELL                     = 1000,
  AQUASHELLPACIFICOYSTER        = 1010, 
  AQUASHELLPACIFICOYSTERCAP     = 1011,
  AQUASHELLPACIFICOYSTERIDREEM  = 1012,
  AQUASHELLPACIFICOYSTERAMC     = 1013,
  AQUASHELLEASTERNOYSTER        = 1020, 
  AQUASHELLEASTERNOYSTERCAP     = 1021, 
  AQUASHELLEASTERNOYSTERSHARES  = 1022,
  AQUASHELLEASTERNOYSTERTEXAS   = 1023, 
  AQUASHELLEASTERNOYSTERTEXASCC = 1024, 
  AQUASHELLPEARLOYSTER          = 1030,
  AQUASHELLEUROPEANOYSTER       = 1033,
  AQUASHELLHONGKONGOYSTER       = 1036, 
  AQUASHELLBLUEMUSSEL           = 1040, 
  AQUASHELLBLUEMUSSELCAP        = 1041,
  AQUASHELLBLUEMUSSELSWELL      = 1042, 
  AQUASHELLBLUEMUSSELIDREEM     = 1043,
  AQUASHELLMEDMUSSEL            = 1050,
  AQUASHELLMEDMUSSELCAP         = 1051, 
  AQUASHELLMEDMUSSELVCR         = 1052,
  AQUASHELLMEDMUSSELAMC         = 1053, 
  AQUASHELLGOODCLAM             = 1060, 
  AQUASHELLMANILACLAM           = 1071,
  AQUASHELLMANILACLAMCAP        = 1072,
  AQUASHELLSOFTSHELLCLAM        = 1080, 
  AQUASHELLGEODUCKCLAM          = 1090,
}

export { AquaShellModel }
